import { default as _91id_93Ua2Hfhg41QMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/accounts/[id].vue?macro=true";
import { default as accountsIKY4Yk3CIAMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/accounts.vue?macro=true";
import { default as analyticsOA3MhdBbaqMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/analytics.vue?macro=true";
import { default as contactsPBdEpv4TjUMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/contacts.vue?macro=true";
import { default as indexnc4D5QB6xrMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/index.vue?macro=true";
import { default as mailboxesYsdvzqT3gRMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/mailboxes.vue?macro=true";
import { default as new8niIuP8CCXMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/new.vue?macro=true";
import { default as scheduleRhFIEsUORaMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/schedule.vue?macro=true";
import { default as _91sequenceId_93S0u79WYrACMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId].vue?macro=true";
import { default as indexo6WHjnwWvJMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/index.vue?macro=true";
import { default as newNggVzaZ4oRMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/new.vue?macro=true";
import { default as outreachbFWT4ZFMfpMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach.vue?macro=true";
import { default as setupCJXtEnnRb5Meta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/setup.vue?macro=true";
import { default as _91icp_93sVLZ9xwDytMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp].vue?macro=true";
import { default as indexRRYJIOqeuIMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/index.vue?macro=true";
import { default as campaignsGoByJqDzb8Meta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns.vue?macro=true";
import { default as discoverHtkJ4tOcTVMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/discover.vue?macro=true";
import { default as indexbjM9tswZ2zMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/index.vue?macro=true";
import { default as opensXH1cRhVK6bMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/opens.vue?macro=true";
import { default as repliesZRpukVCDO5Meta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/replies.vue?macro=true";
import { default as _91listId_93yNO1jH17M2Meta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/[listId].vue?macro=true";
import { default as allz0Blo7zxUzMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/all.vue?macro=true";
import { default as mineMOExk5MIhXMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/mine.vue?macro=true";
import { default as sequences2cegViVLZ5Meta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/sequences.vue?macro=true";
import { default as accountLTHBbxohAtMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/account.vue?macro=true";
import { default as engaged_45accountsnK0gnxDljIMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-accounts.vue?macro=true";
import { default as engaged_45contactsD9b0MODDRpMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-contacts.vue?macro=true";
import { default as exportsPuXW3gzejIMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/exports.vue?macro=true";
import { default as forbidden_45accountsZ1Ic1YfbJqMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-accounts.vue?macro=true";
import { default as forbidden_45contacts28763A4aMGMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-contacts.vue?macro=true";
import { default as imports514oTGj7uaMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/imports.vue?macro=true";
import { default as indexB9Gu1K2lhoMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/index.vue?macro=true";
import { default as integrationsEyef6Pn3w4Meta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/integrations.vue?macro=true";
import { default as mailboxPERfpcZznjMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/mailbox.vue?macro=true";
import { default as notificationsoyBWsIndlUMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/notifications.vue?macro=true";
import { default as organization4REuJTW6mqMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/organization.vue?macro=true";
import { default as replies2jpXMpp9yjMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/replies.vue?macro=true";
import { default as settings4wHFYhWUvrMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings.vue?macro=true";
import { default as advanced_45icp1ilzT1aQwLMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced-icp.vue?macro=true";
import { default as advancedBdhV3c2vBOMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced.vue?macro=true";
import { default as employeeszaFXyTCH00Meta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/employees.vue?macro=true";
import { default as job_45openingslQtS6Cj1n7Meta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/job-openings.vue?macro=true";
import { default as newsw3F5Ze0sXdMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/news.vue?macro=true";
import { default as websitesMvypu8l9UfMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/websites.vue?macro=true";
import { default as signinOccTxbdUmwMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signin.vue?macro=true";
import { default as signupSx8kWfKD5XMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signup.vue?macro=true";
import { default as test56JeJ0TwcvMeta } from "/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/test.vue?macro=true";
export default [
  {
    name: "accounts-id",
    path: "/accounts/:id()",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/accounts/[id].vue")
  },
  {
    name: campaignsGoByJqDzb8Meta?.name,
    path: "/campaigns",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns.vue"),
    children: [
  {
    name: "campaigns-icp",
    path: ":icp()",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp].vue"),
    children: [
  {
    name: "campaigns-icp-accounts",
    path: "accounts",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/accounts.vue")
  },
  {
    name: "campaigns-icp-analytics",
    path: "analytics",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/analytics.vue")
  },
  {
    name: outreachbFWT4ZFMfpMeta?.name,
    path: "outreach",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach.vue"),
    children: [
  {
    name: _91sequenceId_93S0u79WYrACMeta?.name,
    path: ":sequenceId()",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId].vue"),
    children: [
  {
    name: "campaigns-icp-outreach-sequenceId-contacts",
    path: "contacts",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/contacts.vue")
  },
  {
    name: "campaigns-icp-outreach-sequenceId",
    path: "",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/index.vue")
  },
  {
    name: "campaigns-icp-outreach-sequenceId-mailboxes",
    path: "mailboxes",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/mailboxes.vue")
  },
  {
    name: "campaigns-icp-outreach-sequenceId-new",
    path: "new",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/new.vue")
  },
  {
    name: "campaigns-icp-outreach-sequenceId-schedule",
    path: "schedule",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/schedule.vue")
  }
]
  },
  {
    name: "campaigns-icp-outreach",
    path: "",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/index.vue")
  },
  {
    name: "campaigns-icp-outreach-new",
    path: "new",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/new.vue")
  }
]
  },
  {
    name: "campaigns-icp-setup",
    path: "setup",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/setup.vue")
  }
]
  },
  {
    name: "campaigns",
    path: "",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/index.vue")
  }
]
  },
  {
    name: "discover",
    path: "/discover",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/discover.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/index.vue")
  },
  {
    name: "opens",
    path: "/opens",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/opens.vue")
  },
  {
    name: "replies",
    path: "/replies",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/replies.vue")
  },
  {
    name: "saved-listId",
    path: "/saved/:listId()",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/[listId].vue")
  },
  {
    name: "saved-all",
    path: "/saved/all",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/all.vue")
  },
  {
    name: "saved-mine",
    path: "/saved/mine",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/mine.vue")
  },
  {
    name: "sequences",
    path: "/sequences",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/sequences.vue")
  },
  {
    name: settings4wHFYhWUvrMeta?.name,
    path: "/settings",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings.vue"),
    children: [
  {
    name: "settings-account",
    path: "account",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/account.vue")
  },
  {
    name: "settings-engaged-accounts",
    path: "engaged-accounts",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-accounts.vue")
  },
  {
    name: "settings-engaged-contacts",
    path: "engaged-contacts",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-contacts.vue")
  },
  {
    name: "settings-exports",
    path: "exports",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/exports.vue")
  },
  {
    name: "settings-forbidden-accounts",
    path: "forbidden-accounts",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-accounts.vue")
  },
  {
    name: "settings-forbidden-contacts",
    path: "forbidden-contacts",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-contacts.vue")
  },
  {
    name: "settings-imports",
    path: "imports",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/imports.vue")
  },
  {
    name: "settings",
    path: "",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/index.vue")
  },
  {
    name: "settings-integrations",
    path: "integrations",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/integrations.vue")
  },
  {
    name: "settings-mailbox",
    path: "mailbox",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/mailbox.vue")
  },
  {
    name: "settings-notifications",
    path: "notifications",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/notifications.vue")
  },
  {
    name: "settings-organization",
    path: "organization",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/organization.vue")
  },
  {
    name: "settings-replies",
    path: "replies",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/replies.vue")
  }
]
  },
  {
    name: "signals-advanced-icp",
    path: "/signals/advanced-icp",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced-icp.vue")
  },
  {
    name: "signals-advanced",
    path: "/signals/advanced",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced.vue")
  },
  {
    name: "signals-employees",
    path: "/signals/employees",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/employees.vue")
  },
  {
    name: "signals-job-openings",
    path: "/signals/job-openings",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/job-openings.vue")
  },
  {
    name: "signals-news",
    path: "/signals/news",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/news.vue")
  },
  {
    name: "signals-websites",
    path: "/signals/websites",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/websites.vue")
  },
  {
    name: "signin",
    path: "/signin",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signin.vue")
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signup.vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/codebuild/output/src901180818/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/test.vue")
  }
]